(function () {
  'use strict';

  var SECTION_SEL = '#fit-guide';
  var PILL_SEL = '.fit-guide__size-pill';
  var VIDEO_ITEM_SEL = '.fit-guide__video-item';
  var LINK_SEL = '[data-fit-guide-link]';
  var CLOSE_SEL = '[data-fit-guide-close]';
  var MOBILE_MQ = '(max-width: 749px)';

  var section, pills, videoItems, sizeOptionName, availableSizes;
  var syncInProgress = false;
  var modalTrigger = null;
  var modalScrollY = 0;
  var modalKeydownHandler = null;
  var modalBackdropHandler = null;
  var trapHandler = null;

  var FOCUSABLE_SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var IN_TO_CM = 2.54;

  function init() {
    section = document.querySelector(SECTION_SEL);
    if (!section) return;

    sizeOptionName = section.getAttribute('data-size-option-name') || 'Size';
    pills = section.querySelectorAll(PILL_SEL);
    videoItems = section.querySelectorAll(VIDEO_ITEM_SEL);

    // Parse available sizes from JSON data island
    var dataEl = section.querySelector('[data-fit-guide-data]');
    try {
      availableSizes = JSON.parse(dataEl.textContent);
    } catch (e) {
      availableSizes = [];
    }

    // Set initial active size from the first active pill
    var activePill = section.querySelector(PILL_SEL + '.is-active');
    if (activePill) {
      activeSize = activePill.getAttribute('data-size');
    }

    bindPillClicks();
    bindLinkClick();
    bindCloseButton();
    bindInboundSync();
    bindUnitToggle();
    observeVisibility();
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  // --- Size pill click ---
  function bindPillClicks() {
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var size = pill.getAttribute('data-size');
        activateSize(size);
        syncToPdp(size);
      });
    });
  }

  var activeSize = null;
  var transitionDuration = 260;

  function activateSize(size) {
    if (size === activeSize) return;
    var prevSize = activeSize;
    activeSize = size;

    // Update pills
    pills.forEach(function (p) {
      var match = p.getAttribute('data-size') === size;
      p.classList.toggle('is-active', match);
      p.setAttribute('aria-pressed', match ? 'true' : 'false');
    });

    // Crossfade video items
    videoItems.forEach(function (item) {
      var itemSize = item.getAttribute('data-size');
      var video = item.querySelector('video');

      if (itemSize === size) {
        // Incoming: start playing before fade-in so first frame is visible
        if (video) {
          video.play().catch(function () {});
        }
        item.classList.remove('is-exiting');
        item.classList.add('is-active');
      } else if (itemSize === prevSize) {
        // Outgoing: fade out, then clean up
        item.classList.add('is-exiting');
        item.classList.remove('is-active');
        (function (el, v) {
          setTimeout(function () {
            el.classList.remove('is-exiting');
            if (v) {
              v.pause();
              v.currentTime = 0;
            }
          }, transitionDuration);
        })(item, video);
      } else {
        // Other items: ensure hidden
        item.classList.remove('is-active', 'is-exiting');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }

  // --- PDP link click: open modal on all viewports ---
  function bindLinkClick() {
    var links = document.querySelectorAll(LINK_SEL);
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(link);
      });
    });
  }

  function bindCloseButton() {
    var closeBtn = section.querySelector(CLOSE_SEL);
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
  }

  // --- Mobile fullscreen modal ---
  function openModal(triggerEl) {
    if (!section || section.classList.contains('is-modal-open')) return;

    modalTrigger = triggerEl || null;

    // Default to the "See on Models" tab when present so the video is visible.
    // When a product has no fit videos the tab doesn't exist, and the section's
    // server-rendered default tab (Find your size / Product measurements) stands.
    var modelsTabEl = section.querySelector('[id^="tab-models-"]');
    if (modelsTabEl && modelsTabEl.getAttribute('aria-selected') !== 'true') {
      modelsTabEl.click();
    }

    // Save scroll position and freeze body (iOS-safe scroll lock)
    modalScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('fit-guide-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + modalScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    // Promote section to dialog
    section.classList.add('is-modal-open');
    section.setAttribute('role', 'dialog');
    section.setAttribute('aria-modal', 'true');
    section.setAttribute('aria-label', 'Size & Fit Guide');

    // Reveal modal header for AT
    var header = section.querySelector('.fit-guide__modal-header');
    if (header) header.removeAttribute('aria-hidden');

    // Focus close button
    var closeBtn = section.querySelector(CLOSE_SEL);
    if (closeBtn) {
      // requestAnimationFrame so the element is laid out before focus
      requestAnimationFrame(function () { closeBtn.focus(); });
    }

    // ESC to close
    modalKeydownHandler = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.stopPropagation();
        closeModal();
      }
    };
    document.addEventListener('keydown', modalKeydownHandler);

    // Backdrop click to close (desktop card variant — mobile is fullscreen)
    modalBackdropHandler = function (e) {
      if (isMobile()) return;
      if (section.contains(e.target)) return;
      if (modalTrigger && modalTrigger.contains(e.target)) return;
      closeModal();
    };
    // Defer one frame so the click that opened the modal doesn't immediately close it
    requestAnimationFrame(function () {
      document.addEventListener('mousedown', modalBackdropHandler);
    });

    // Make sure the active video plays now that it's visible
    var activeItem = section.querySelector(VIDEO_ITEM_SEL + '.is-active');
    if (activeItem) {
      var v = activeItem.querySelector('video');
      if (v) v.play().catch(function () {});
    }

    enableTrap();
  }

  function closeModal() {
    if (!section || !section.classList.contains('is-modal-open')) return;

    // Pause active video to free decoder
    var activeItem = section.querySelector(VIDEO_ITEM_SEL + '.is-active');
    if (activeItem) {
      var v = activeItem.querySelector('video');
      if (v) v.pause();
    }

    // Demote dialog
    section.classList.remove('is-modal-open');
    section.removeAttribute('role');
    section.removeAttribute('aria-modal');
    section.removeAttribute('aria-label');

    var header = section.querySelector('.fit-guide__modal-header');
    if (header) header.setAttribute('aria-hidden', 'true');

    // Unfreeze body and restore scroll
    document.body.classList.remove('fit-guide-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, modalScrollY);

    // ESC handler off
    if (modalKeydownHandler) {
      document.removeEventListener('keydown', modalKeydownHandler);
      modalKeydownHandler = null;
    }

    // Backdrop handler off
    if (modalBackdropHandler) {
      document.removeEventListener('mousedown', modalBackdropHandler);
      modalBackdropHandler = null;
    }

    disableTrap();

    // Return focus to trigger
    if (modalTrigger && typeof modalTrigger.focus === 'function') {
      modalTrigger.focus();
    }
    modalTrigger = null;
  }

  // --- Focus trap (active only while the modal is open) ---
  function visibleFocusables() {
    return Array.prototype.filter.call(
      section.querySelectorAll(FOCUSABLE_SEL),
      function (el) { return el.offsetParent !== null; } // skip hidden tab panels / display:none
    );
  }

  function enableTrap() {
    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var f = visibleFocusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      if (!section.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    // Capture phase so the trap runs before the theme's global handlers.
    document.addEventListener('keydown', trapHandler, true);
  }

  function disableTrap() {
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler, true);
      trapHandler = null;
    }
  }

  // --- CM / IN toggle: rewrites every measurement table in the section ---
  function trimZeros(num) {
    // num is already a multiple of 0.25; JS number->string yields no trailing
    // zeros (10 -> "10", 37.5 -> "37.5", 37.75 -> "37.75"). Round guards FP noise.
    return Math.round(num * 100) / 100 + '';
  }

  function cmCellToIn(cmStr) {
    // Handle ranges ("96-101", en-dash "96–101") and plain values; round to 0.25".
    return cmStr.split(/\s*[-–]\s*/).map(function (part) {
      var v = parseFloat(part);
      if (!isFinite(v)) return part; // blank / non-numeric ("One size") -> passthrough
      return trimZeros(Math.round((v / IN_TO_CM) / 0.25) * 0.25);
    }).join('–');
  }

  function setUnit(unit) {
    if (!section) return;
    var cells = section.querySelectorAll('[data-size-table] td[data-cm]');
    Array.prototype.forEach.call(cells, function (td) {
      var cm = td.getAttribute('data-cm');
      if (cm === '' || cm === null) { td.textContent = ''; return; }
      td.textContent = (unit === 'in') ? cmCellToIn(cm) : cm;
    });
    var btns = section.querySelectorAll('.fit-guide__unit');
    Array.prototype.forEach.call(btns, function (b) {
      var on = b.getAttribute('data-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function bindUnitToggle() {
    var btns = section.querySelectorAll('.fit-guide__unit');
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-unit')); });
    });
    // DOM renders CM by default (cm button pre-marked active) — no initial pass needed.
  }

  // --- Inbound sync: PDP variant picker -> fit guide ---
  function bindInboundSync() {
    document.addEventListener('on:variant:change', function (e) {
      if (syncInProgress) return;

      var selectedOptions = e.detail && e.detail.selectedOptions;
      if (!selectedOptions) return;

      // Find the size value from selectedOptions
      // selectedOptions is an array matching product.options order
      // We need to find which index corresponds to the size option
      var sizeFieldset = document.querySelector(
        '.option-selector[data-option="' + sizeOptionName + '"]'
      );
      if (!sizeFieldset) return;

      var optionIndex = parseInt(sizeFieldset.getAttribute('data-index'), 10);
      // data-index is 1-based (option.position), selectedOptions is 0-based array
      var selectedSize = selectedOptions[optionIndex - 1];
      if (!selectedSize) return;

      // Only activate if we have a matching fit entry
      if (availableSizes.indexOf(selectedSize) !== -1) {
        activateSize(selectedSize);
      }
    });
  }

  // --- Outbound sync: fit guide -> PDP ---
  function syncToPdp(size) {
    syncInProgress = true;

    var sizeFieldset = document.querySelector(
      '.option-selector[data-option="' + sizeOptionName + '"]'
    );
    if (!sizeFieldset) {
      syncInProgress = false;
      return;
    }

    var input = sizeFieldset.querySelector('input[value="' + CSS.escape(size) + '"]');
    if (input && !input.checked) {
      // Lock scroll position during the variant change to prevent jump
      var scrollY = window.scrollY;
      var lockScroll = function () { window.scrollTo(0, scrollY); };
      window.addEventListener('scroll', lockScroll);

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Release scroll lock after theme re-render completes
      setTimeout(function () {
        window.removeEventListener('scroll', lockScroll);
      }, 600);
    }

    // Reset guard after the theme's async fetch completes
    setTimeout(function () {
      syncInProgress = false;
    }, 700);
  }

  // --- Pause/resume video based on visibility ---
  function observeVisibility() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var activeItem = section.querySelector(VIDEO_ITEM_SEL + '.is-active');
          if (!activeItem) return;
          var video = activeItem.querySelector('video');
          if (!video) return;

          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(section);
  }

  // --- Handle arrival via #fit-guide hash (e.g. from quick buy link) ---
  function handleHash() {
    if (window.location.hash === '#fit-guide' && section) {
      // Small delay so the page finishes layout before opening
      setTimeout(function () {
        openModal(null);
      }, 300);
    }
  }

  // --- Init ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); handleHash(); });
  } else {
    init();
    handleHash();
  }
})();
